<template>
  <component :is="logoComponent" class="app-logo" :class="mainClasses" alt="Allposit" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { LogoSize } from './utils/enums'

import LogoSvg from '@/assets/images/logo.svg'
import LogoTextSvg from '@/assets/images/logo-text.svg'

type Props = {
  size?: LogoSize
  full?: boolean
}

const props = defineProps<Props>()

defineOptions({ name: 'AppLogo' })

const mainClasses = computed(() => ({
  [`app-logo--${props.size}`]: props.size,
  'app-logo--full': props.full,
}))

const logoComponent = computed(() => props.full ? LogoTextSvg : LogoSvg)
</script>

<style>
.app-logo {
  @apply h-6;

  &--lg {
    @apply h-11;
  }
}
</style>
